import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onConsentChange }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [consentGiven, setConsentGiven] = useState(null);

    useEffect(() => {
        // Check if user has already given consent
        const savedConsent = localStorage.getItem('cospin_cookie_consent');
        if (savedConsent === null) {
            // Show consent banner if no decision made
            setIsVisible(true);
        } else {
            setConsentGiven(savedConsent === 'true');
            // Notify parent component
            if (onConsentChange) {
                onConsentChange(savedConsent === 'true');
            }
        }
    }, [onConsentChange]);

    const handleAccept = () => {
        setConsentGiven(true);
        setIsVisible(false);
        localStorage.setItem('cospin_cookie_consent', 'true');

        if (onConsentChange) {
            onConsentChange(true);
        }
    };

    const handleDecline = () => {
        setConsentGiven(false);
        setIsVisible(false);
        localStorage.setItem('cospin_cookie_consent', 'false');

        if (onConsentChange) {
            onConsentChange(false);
        }
    };



    if (!isVisible) {
        return null;
    }

    return (
        <div className="cookie-consent">
            <div className="cookie-consent-content">
                <div className="cookie-consent-text">
                    <h4>🍪 We use cookies to enhance your experience</h4>
                    <p>
                        We use cookies and similar technologies to analyze site traffic,
                        understand where our visitors are coming from, and improve our website.
                        By clicking "Accept All", you consent to our use of cookies for analytics
                        and performance purposes.
                    </p>
                </div>

                <div className="cookie-consent-actions">
                    <button
                        className="cookie-consent-btn cookie-consent-btn-secondary"
                        onClick={handleDecline}
                    >
                        Decline
                    </button>
                    <button
                        className="cookie-consent-btn cookie-consent-btn-primary"
                        onClick={handleAccept}
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
